import useCatchHandler from "@/services/catchErrorHandler"
import useOAuth from "@/services/oauth"
import { useStore } from "@/store"
import axios from "axios"
import { computed } from "vue"
// @ts-ignore
import { toast } from "/src/plugins/vue3-toastify.plugin"

export default function useApiAssessmentDownloadReport() {
    const { handleError } = useCatchHandler()
    const { API_PREFIX } = useOAuth()
    const store = useStore()
    const getApiRequestHeader = computed(
        () => store.getters.getApiRequestHeader
    )
    const apiDownloadAssessmentAnswersFile = async (
        id: string,
        fileType: string,
        timeZone: string,
        downloadAll: boolean,
        reportType: string
    ) => {
        try {
            const body = {
                id,
                fileType,
                timeZone: timeZone,
                downloadAll,
                reportType,
            }
            const response: any = await axios.post(
                `${API_PREFIX}/assessment/${id}/candidates/reports/answers/download/${fileType}`,
                body,
                getApiRequestHeader.value
            )
            return response
        } catch ({ response }) {
            handleError(response)
            return
        }
    }

    const apiDownloadAssessmentSectionFile = async (
        id: string,
        fileType: string,
        timeZone: string,
        downloadAll: boolean,
        reportType: string
    ) => {
        try {
            const body = {
                id,
                fileType,
                timeZone: timeZone,
                downloadAll,
                reportType,
            }
            const response: any = await axios.post(
                `${API_PREFIX}/assessment/${id}/candidates/reports/sectionDetail/download/${fileType}`,
                body,
                getApiRequestHeader.value
            )
            return response
        } catch ({ response }) {
            handleError(response)
            return
        }
    }

    const apiGetAssessmentReportDownload = async (jobId: string) => {
        try {
            const response: any = await axios.get(
                `${API_PREFIX}/workspace/job/${jobId}/status`,
                getApiRequestHeader.value
            )
            return response
        } catch ({ response }) {
            handleError(response)
            return -1
        }
    }

    return {
        apiDownloadAssessmentAnswersFile,
        apiDownloadAssessmentSectionFile,
        apiGetAssessmentReportDownload,
    }
}
